import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/home/Home'
import EnHome from '@/components/en/home/EnHome'
import About from '@/components/about/About'
import EnAbout from '@/components/en/about/About'
import companyIntroduce from '@/components/about/companyIntroduce'
import EncompanyIntroduce from '@/components/en/about/companyIntroduce'
import developmentHistoryBox from '@/components/about/developmentHistoryBox'
import honorBox from '@/components/about/honorBox'
import EnhonorBox from '@/components/en/about/honorBox'
import contactBox from '@/components/about/contactBox'
import EncontactBox from '@/components/en/about/contactBox'
import group from '@/components/about/group'
import Engroup from '@/components/en/about/group'

import Business from '@/components/business/Business'
import EnBusiness from '@/components/en/business/Business'

import SocialResponsibility from '@/components/socialResponsibility/SocialResponsibility'
import EnSocialResponsibility from '@/components/en/socialResponsibility/SocialResponsibility'

import NewList from '@/components/newList/NewList'
import NewListCon from '@/components/newList/NewListCon'
import NewDetail from '@/components/newDetail/NewDetail'
import Campus from '@/components/campus/Campus'
import CampusCon from '@/components/campus/CampusCon'

import LegalDeclaration from '@/components/legalDeclaration/legalDeclaration'
import EnLegalDeclaration from '@/components/en/legalDeclaration/legalDeclaration'


// 投资者关系
import Investor from '@/components/investor/Investor'
import CorporateGovernance from '@/components/investor/CorporateGovernance'
import BoardMember from '@/components/investor/BoardMember'
import Overview from '@/components/investor/Overview'
import OfferDocuments from '@/components/investor/OfferDocuments'
import PeriodicalReport from '@/components/investor/PeriodicalReport'
import ImportantAnnouncement from '@/components/investor/ImportantAnnouncement'
import InvestorContact from '@/components/investor/InvestorContact'


import EnInvestor from '@/components/en/investor/Investor'
import EnCorporateGovernance from '@/components/en/investor/CorporateGovernance'
import EnBoardMember from '@/components/en/investor/BoardMember'
import EnOverview from '@/components/en/investor/Overview'
import EnOfferDocuments from '@/components/en/investor/OfferDocuments'
import EnPeriodicalReport from '@/components/en/investor/PeriodicalReport'
import EnImportantAnnouncement from '@/components/en/investor/ImportantAnnouncement'
import EnInvestorContact from '@/components/en/investor/InvestorContact'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: {name: 'Home'},
    },
    {
      path: '/index',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About, children: [
        {
          path: 'companyIntroduce',
          name: 'companyIntroduce',
          component: companyIntroduce
        },
        {
          path: 'developmentHistoryBox',
          name: 'developmentHistoryBox',
          component: developmentHistoryBox
        },
        {
          path: 'honorBox',
          name: 'honorBox',
          component: honorBox
        },
        {
          path: 'contactBox',
          name: 'contactBox',
          component: contactBox
        },
        {
          path: 'group',
          name: 'group',
          component: group
        }
      ]
    },
    {
      path: '/business',
      name: 'Business',
      component: Business
    },
    {
      path: '/socialResponsibility',
      name: 'SocialResponsibility',
      component: SocialResponsibility
    },
    {
      path: '/newList',
      name: 'NewList',
      component: NewList, children: [
        {
          path: 'NewListCon',
          name: 'NewListCon',
          component: NewListCon
        }
      ]
    },
    {
      path: '/newDetail',
      name: 'NewDetail',
      component: NewDetail
    },
    {
      path: '/campus',
      name: 'Campus',
      component: Campus, children: [
        {
          path: 'CampusCon',
          name: 'CampusCon',
          component: CampusCon
        },
      ]
    },
    {
      path: '/legalDeclaration',
      name: 'LegalDeclaration',
      component: LegalDeclaration
    },
    {
      path: '/investor',
      name: 'Investor',
      component: Investor,
      children: [
        {
          path: 'corporateGovernance',
          name: 'CorporateGovernance',
          component: CorporateGovernance,
          children: [
            {
              path: 'overview',
              name: 'Overview',
              component: Overview
            },
            {
              path: 'boardMember',
              name: 'BoardMember',
              component: BoardMember
            }
          ]
        },
        {
          path: 'offerDocuments',
          name: 'OfferDocuments',
          component: OfferDocuments
        },
        {
          path: 'periodicalReport',
          name: 'PeriodicalReport',
          component: PeriodicalReport
        },
        {
          path: 'importantAnnouncement',
          name: 'ImportantAnnouncement',
          component: ImportantAnnouncement
        },
        {
          path: 'investorContact',
          name: 'InvestorContact',
          component: InvestorContact
        }
      ]
    },
    {
      path: '/en',
      redirect: {name: 'EnHome'},
    },
    {
      path: '/en/index',
      name: 'EnHome',
      component: EnHome
    },
    {
      path: '/en/legalDeclaration',
      name: 'EnLegalDeclaration',
      component: EnLegalDeclaration
    },
    {
      path: '/en/about',
      name: 'EnAbout',
      component: EnAbout, children: [
        {
          path: 'companyIntroduce',
          name: 'EncompanyIntroduce',
          component: EncompanyIntroduce
        },
        {
          path: 'honorBox',
          name: 'EnhonorBox',
          component: EnhonorBox
        },
        {
          path: 'contactBox',
          name: 'EncontactBox',
          component: EncontactBox
        },
        {
          path: 'group',
          name: 'Engroup',
          component: Engroup
        },
      ]
    },
    {
      path: '/en/business',
      name: 'EnBusiness',
      component: EnBusiness
    },
    {
      path: '/en/socialResponsibility',
      name: 'EnSocialResponsibility',
      component: EnSocialResponsibility
    },
    {
      path: '/en/investor',
      name: 'EnInvestor',
      component: EnInvestor,
      children: [
        {
          path: 'corporateGovernance',
          name: 'EnCorporateGovernance',
          component: EnCorporateGovernance,
          children: [
            {
              path: 'overview',
              name: 'EnOverview',
              component: EnOverview
            },
            {
              path: 'boardMember',
              name: 'EnBoardMember',
              component: EnBoardMember
            }
          ]
        },
        {
          path: 'EnOfferDocuments',
          name: 'EnOfferDocuments',
          component: EnOfferDocuments
        },
        {
          path: 'EnPeriodicalReport',
          name: 'EnPeriodicalReport',
          component: EnPeriodicalReport
        },
        {
          path: 'EnImportantAnnouncement',
          name: 'EnImportantAnnouncement',
          component: EnImportantAnnouncement
        },
        {
          path: 'EnInvestorContact',
          name: 'EnInvestorContact',
          component: EnInvestorContact
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js